export enum PermissionValues {
  GROUP = '/usergroup/',
  TENANT = '/tenant/'
}